



































































import {
  DashboardVendedorService,
  FechamentoVendedorRelatorioItem,
} from "@/services/dashboard-vendedor.service";
import SelectYearMounth from "@/shared/components/select-year-mounth.vue";
import dayjs from "dayjs";
import { Component, Vue, Watch } from "vue-property-decorator";
import * as XLSX from "xlsx";

@Component({
  components: {
    SelectYearMounth,
  },
})
export default class RelatorioFechamentoVendedores extends Vue {
  loading = false;
  carregouRelatorio = false;
  mesAno: string = dayjs().subtract(1, "month").format("YYYY-MM");
  relatorio: FechamentoVendedorRelatorioItem[] = [];

  headers = [
    { text: "Nome do Vendedor", value: "nomeVendedor" },
    { text: "Data de Fechamento", value: "dataFechamento" },
    { text: "Bonificação Nível", value: "bonificacaoNivel" },
    { text: "Bonificação Meta", value: "bonificacaoMeta" },
    { text: "Bonificação Total", value: "bonificacaoTotal" },
    { text: "Total de Pontos", value: "totalPontos" },
    { text: "Posição no Ranking", value: "posicaoRanking" },
  ];

  async mounted() {
    await this.carregarRelatorio();
  }

  @Watch("mesAno")
  async onChangeMesAno() {
    await this.carregarRelatorio();
  }

  async carregarRelatorio(): Promise<boolean> {
    this.loading = true;

    const relatorio = await DashboardVendedorService.ObterRelatorioFechamento(
      this.mesAno,
    ).finally(() => {
      this.loading = false;
    });

    this.relatorio = relatorio || [];
    this.carregouRelatorio = true;

    if (this.relatorio.length === 0) {
      return false;
    }

    return true;
  }

  async exportarRelatorio() {
    if (this.relatorio.length === 0) {
      const carregou = await this.carregarRelatorio();
      if (!carregou) {
        return;
      }
    }

    const dadosExportacao = this.relatorio.map(
      (item: FechamentoVendedorRelatorioItem) => ({
        "Nome do Vendedor": item.nomeVendedor,
        "Data de Fechamento": item.dataFechamento
          ? dayjs(item.dataFechamento).toDate()
          : null,
        "Bonificação Meta": item.bonificacaoMeta,
        "Bonificação Nível": item.bonificacaoNivel,
        "Bonificação Total": item.bonificacaoTotal,
        "Total de Pontos": item.totalPontos,
        "Posição no Ranking": item.posicaoRanking,
      }),
    );

    const worksheet = XLSX.utils.json_to_sheet(dadosExportacao, {
      cellDates: true,
      dateNF: "dd/mm/yyyy",
    });

    worksheet["!cols"] = [
      { wch: 35 },
      { wch: 20 },
      { wch: 20 },
      { wch: 20 },
      { wch: 20 },
      { wch: 18 },
      { wch: 20 },
    ];

    const workbook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(workbook, worksheet, "Relatorio");
    XLSX.writeFile(
      workbook,
      `relatorio-fechamento-vendedores-${this.mesAno}.xlsx`,
    );
  }

  formatarData(data: string): string {
    return data ? dayjs(data).format("DD/MM/YYYY") : "-";
  }

  formatarMoeda(valor: number): string {
    return Number(valor || 0).toLocaleString("pt-BR", {
      style: "currency",
      currency: "BRL",
    });
  }
}
